import React from 'react';
import styled from 'styled-components';

import Layout from '@/layout';

import Hero from './components/Hero';
import About from './components/About';
import Brands from './components/Brands';
import Gallery from './components/Gallery';
import CatalogCars from './components/CatalogCars';
import Videos from './components/Videos';
import Credit from './components/Credit';
import TradeIn from './components/TradeIn';
import ServiceBanner from './components/ServiceBanner';
import AboutDealer from './components/AboutDealer';
import ConsultationForm from './components/ConsultationForm';
import Dealers from './components/Dealers';
import Contacts from './components/Contacts';

function TopLevelFunnelLanding() {
  return (
    <Layout>
      <Component>
        <Hero />
        <About />
        <Brands />
        <Gallery />
        <CatalogCars />
        <Videos />
        <Credit />
        <TradeIn />
        <ServiceBanner />
        <AboutDealer />
        <Dealers />
        <ConsultationForm />
        <Contacts />
      </Component>
    </Layout>
  );
}

export default TopLevelFunnelLanding;

const Component = styled.section`
  flex: 1;
  display: flex;
  flex-direction: column;
  background: ${(props) => props.theme.white};
`;
